<template>
  <div>
    <Heading title="Blog posts" subTitle="Configure look &amp; feel of AMP for blog posts." targetPlan="pro" tryForFree />

    <div class="accordion mb-45" id="post-collapse-group">
      <CollapseItem open label="Title" parent="#post-collapse-group" highlight=".h4.article-title">
        <Customizer
          category="postTitle"
          basic
          font
          space :spaceConfig="{ hidePadding: true }">
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="postTitle" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Author" parent="#post-collapse-group" highlight="span.article-author">
        <Customizer
          category="postAuthor"
          basic
          font :fontConfig="{ hideTextAlign: true }">
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="postAuthor" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Date" parent="#post-collapse-group" highlight="span.article-date">
        <Customizer
          category="postDate"
          basic
          font :fontConfig="{ hideTextAlign: true }">
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="postDate" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Disqus comments" parent="#post-collapse-group" highlight=".disqus-comments">
        <Customizer
          basic>
          <Alert icon="IconMoodHappy" class="alert-info">
            <p class="mb-0">To see preview of Disqus comments, please select a blog post from your store for preview and save the settings.</p>
          </Alert>
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Disqus Shortname</label>
              <input type="url" class="form-control" v-model="language__disqus" />
              <small class="form-text text-muted">The unique identifier for your website as registered on Disqus.</small>
              <small class="form-text text-muted">Leave this field blank to disable Disqus comments.</small>
            </div>
          </div>
        </Customizer>
      </CollapseItem>
    </div>

    <Heading h2 title="Related Articles" />

    <div class="accordion mb-45">
      <CollapseItem label="Heading" parent="#articles-collapse-group" highlight=".recent-articles-title">
        <Customizer
          category="postRecentPostsHeading"
          basic
          font
          space
          border :borderConfig="{ hideBorderRadius: true }">
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="postRecentPostsHeading" type="color" />
            </div>
            <div class="col-md-6">
              <label>Heading Text</label>
              <input type="text" class="form-control" v-model="language__recent_articles_title_text">
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Title" parent="#articles-collapse-group" highlight=".recent-articles p">
        <Customizer
          category="postRecentPostsTitle"
          basic
          font>
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="postRecentPostsTitle" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
      <CollapseItem label="Date" parent="#articles-collapse-group" highlight=".recent-articles time">
        <Customizer
          category="postRecentPostsDate"
          basic
          font>
          <div class="row row-space-4">
            <div class="col-md-6">
              <label>Text Color</label>
              <ColorCustomizer
                category="postRecentPostsDate" type="color" />
            </div>
          </div>
        </Customizer>
      </CollapseItem>
    </div>

    <div class="card bs mb-45">
      <div class="card-body">
        <h5 class="mb-3">Refresh posts</h5>
        <div class="form-group font-weight-normal">
          <p>Superchargify can automagically detect changes in resources across your store, except for blog posts</p>
          <p class="mb-0">Submit a request to refresh blog posts when you create or modify them.</p>
        </div>
        <ProcessButton type="blogs" successText="Your content is being refreshed." />
      </div>
    </div>

    <p class="mb-0 font-weight-normal text-muted">Advance customisation options for blog posts are coming in Q1 2020.</p>

    <SaveButton :hasChanged="hasChanged" @click="saveMaster" bar discard />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import CollapseItem from '@/components/CollapseItem'
import Customizer from '@/components/customizers/Customizer'

import ColorCustomizer from '@/components/customizers/ColorCustomizer'
import SaveButton from '@/components/SaveButton'
import UpgradeBadge from '@/components/UpgradeBadge'
import ProcessButton from '@/components/ProcessButton'

import update from '@/mixins/update'
import watchForChange from '@/mixins/watchForChange'
import mapMultiComputed from '@/mixins/mapMultiComputed'

export default {
  mixins: [
    update,
    watchForChange(),
    mapMultiComputed('settings', [
      'language.recent_articles_title_text',
      'language.disqus'
    ])
  ],
  components: {
    Customizer,
    CollapseItem,
    SaveButton,
    UpgradeBadge,
    ProcessButton,
    ColorCustomizer
  },
  computed: mapState([ 'currentPreviewType' ]),
  methods: mapActions([ 'saveMaster' ]),
  mounted: function () {
    if (this.currentPreviewType !== 'post') {
      this.$store.commit('SWITCH_PREVIEW_TYPE', 'post')
    }
  }
}
</script>
